import { log } from '@/shared/lib/logging';

import { isTrackingEnabled } from './config';

// Event deduplication tracking
const trackedEvents = new Map<string, Set<string>>();

// Legacy init function - now handled by React Helmet in provider
// Kept for backward compatibility but deprecated
export function fbInit(): void {
    log(
        '[Meta Pixel] fbInit is deprecated - initialization now handled by React Helmet in MetaPixelProvider',
    );
}

// Event simple with deduplication
export function fbEvent(
    eventName: string,
    params?: Record<string, unknown>,
): void {
    // Create event signature for deduplication
    const eventSignature = `${eventName}:${JSON.stringify(params || {})}`;

    // Check if this exact event was already tracked
    if (!trackedEvents.has(eventName)) {
        trackedEvents.set(eventName, new Set());
    }

    const eventSet = trackedEvents.get(eventName)!;

    if (eventSet.has(eventSignature)) {
        log(`[Meta Pixel] Event "${eventName}" (duplicate, skipped)`, params);

        return;
    }

    // Mark this event as tracked
    eventSet.add(eventSignature);

    if (!isTrackingEnabled()) {
        log(`[Meta Pixel] Event "${eventName}" (disabled in dev mode)`, params);

        return;
    }

    if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', eventName, params);
        log(`[Meta Pixel] Event "${eventName}" tracked`, params);
    } else {
        log(
            `[Meta Pixel] Event "${eventName}" failed - fbq not available`,
            params,
        );
    }
}

// Clear event deduplication cache (useful for testing or session changes)
export function clearEventCache(): void {
    trackedEvents.clear();
    log('[Meta Pixel] Event deduplication cache cleared');
}

// Alias for compatibility
export const fbPageView = (params?: Record<string, unknown>) =>
    fbEvent('PageView', params);
export const initFacebookPixel = fbInit;
